export const OCCUPIED = 'OCCUPIED'

export const SEAT_TYPES = {
    CLASSIC: 'classic',
    WHEELCHAIR: 'wheelchair',
    POSITIONABLE: 'positionable',
    VIP: 'vip',
    GOLD: 'gold',
    DELUXE: 'deluxe',
    RESERVED: 'reserved',
    VIP_DOUBLE: 'vip_double',
    BOUTIQUE: 'boutique',
}

export const SEAT_SIZES = {
    SINGLE: 'single',
    DOUBLE: 'double',
}

export const SEAT_IDS = {
    CLASSIC: 1,
    WHEELCHAIR: 2,
    CLASSIC_DOUBLE: 3,
    GOLD: 7,
    VIP: 8,
    ATMOS: 10,
    ATMOS_DOUBLE: 11,
    ATMOS_VIP: 12,
    ATMOS_WHEELCHAIR: 13,
    GOLD_WHEELCHAIR: 14,
    POSITIONABLE: 15,
    POSITIONABLE_DOUBLE: 16,
    TDL: 17,
    TDL_WHEELCHAIR: 18,
    TDL_FAMILY_WHEELCHAIR: 20,
    VIP_DOUBLE: 21,
    BOUTIQUE: 22,
    BOUTIQUE_WHEELCHAIR: 23,
}
